if (!customElements.get('background-video')) {
    customElements.define('background-video',
    class BackgroundVideo extends HTMLElement {
      constructor() {
        super();
        this.mobileBreakpoint = 749;
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
        this.videoLoaded = false;
        this.handleMediaChange = this.handleMediaChange.bind(this);
        BackgroundVideo.intersectionObserver = BackgroundVideo.intersectionObserver || null;
      }

      connectedCallback() {
        this.desktopVideo = this.querySelector('[data-video]');
        this.mobileVideo = this.querySelector('[data-video-mobile]');
        this.hasMobileVideo = !!this.mobileVideo;

        this.muteButton = this.querySelector('[data-mute-button]');
        if (this.muteButton) {
          this.muteButton.addEventListener('click', this.toggleMute.bind(this));
        }

        this.mediaQuery = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`);
        this.mediaQuery.addEventListener('change', this.handleMediaChange);

        const instantLoad = this.dataset.instantLoad === "true";

        if (instantLoad) {
          this.loadVideo();
        } else {
          this.setupIntersectionObserver();
        }
      }

      disconnectedCallback() {
        if (BackgroundVideo.intersectionObserver) {
          BackgroundVideo.intersectionObserver.unobserve(this);
        }
        if (this.mediaQuery) {
          this.mediaQuery.removeEventListener('change', this.handleMediaChange);
        }
      }

      setupIntersectionObserver() {
        if (!BackgroundVideo.intersectionObserver) {
          BackgroundVideo.intersectionObserver = new IntersectionObserver(
            (entries, obs) => {
              entries.forEach((entry) => {
                const el = entry.target;
                if (entry.isIntersecting && !el.videoLoaded) {
                  el.loadVideo();
                  obs.unobserve(entry.target);
                }
              });
            },
            {
              rootMargin: '200px 0px', // Start loading 200px before viewport
              threshold: 0
            }
          );
        }

        BackgroundVideo.intersectionObserver.observe(this);
      }

      loadVideo() {
        if (this.videoLoaded) return;
        this.videoLoaded = true;

        const video = this.getCurrentVideo();
        if (!video) return;

        video.querySelectorAll('source').forEach((s) => { s.src = s.dataset.src });
        video.load();

        video.addEventListener('loadeddata', () => {
          this.handleVideoReady(video);
        }, { once: true });
      }

      getCurrentVideo() {
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
        return this.isMobile && this.hasMobileVideo ? this.mobileVideo : this.desktopVideo;
      }

      handleVideoReady(video) {
        video.addEventListener('timeupdate', () => {
          video.classList.add('video--is-playing');
        }, { once: true });

        video.play().then(() => {         
        }).catch((error) => {
          console.warn('Video autoplay prevented:', error);
        });
      }

      toggleMute() {
        const muted = !this.muteButton.classList.contains('is-muted');

        [this.desktopVideo, this.mobileVideo].forEach((video) => {
          if (video) video.muted = muted;
        });

        this.muteButton.classList.toggle('is-muted', muted);
        this.muteButton.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      handleMediaChange(event) {
        this.isMobile = event.matches;
        this.loadVideo();
        
      }
    }
  )
}